<vex-page-layout mode="card">
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Desaparecidos</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content>
        <div class="card">
            <mat-tab-group>
                <mat-tab label="Datos del caso">
                    <div class="p-6">
                        <div class="grid grid-flow-col gap-3">
                            <div class="col-span-1">
                                <div class="px-6 py-4 border-b flex items-center">
                                    <h2 class="title m-0 flex-auto">Datos del caso</h2>
                                    <button mat-icon-button type="button" matTooltip="Publicar"
                                        (click)="publicar()">
                                        <mat-icon class="text-secondary" svgIcon="mat:start"></mat-icon>
                                    </button>
                                    <button mat-icon-button type="button" matTooltip="Reporte en pdf"
                                        (click)="downloadPdf()">
                                        <mat-icon class="text-secondary" svgIcon="mat:picture_as_pdf"></mat-icon>
                                    </button>
                                    <button mat-icon-button type="button" matTooltip="Reporte en imagen"
                                        (click)="downloadImage()">
                                        <mat-icon class="text-secondary" svgIcon="mat:image"></mat-icon>
                                    </button>
                                </div>
                                <div class="px-6 py-4 flex flex-col">
                                    <form (ngSubmit)="nothing()" [formGroup]="form" novalidate>
                                        <div class="px-6 py-4 flex flex-col">
                                            <mat-accordion multi>
                                                <mat-expansion-panel [expanded]="true">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>Datos personales</mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Nombres</mat-label>
                                                            <input matInput formControlName="nombres">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Apellido paterno</mat-label>
                                                            <input matInput formControlName="apellidoPaterno">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Apellido materno</mat-label>
                                                            <input matInput formControlName="apellidoMaterno">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Documento</mat-label>
                                                            <input matInput formControlName="documento">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Complemento</mat-label>
                                                            <input matInput formControlName="complemento">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Fecha nacimiento</mat-label>
                                                            <input matInput formControlName="fechaNacimiento">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Sexo</mat-label>
                                                            <input matInput formControlName="sexo">
                                                        </mat-form-field>

                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Edad</mat-label>
                                                            <input matInput formControlName="edad">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Nacionalidad</mat-label>
                                                            <input matInput formControlName="nacionalidad">
                                                        </mat-form-field>
                                                    </div>
                                                </mat-expansion-panel>
                                                <mat-expansion-panel [expanded]="true">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>Datos de identificación</mat-panel-title>
                                                    </mat-expansion-panel-header>

                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Fecha de desaparición</mat-label>
                                                            <input matInput formControlName="fechaDesaparicion">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Ojos</mat-label>
                                                            <input matInput formControlName="colorOjos">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Cabello</mat-label>
                                                            <input matInput formControlName="colorCabellos">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Tez</mat-label>
                                                            <input matInput formControlName="tez">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Estatura</mat-label>
                                                            <input matInput formControlName="estatura">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Peso</mat-label>
                                                            <input matInput formControlName="peso">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Numero de telefono referencia</mat-label>
                                                            <input matInput formControlName="referencia">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Gestion</mat-label>
                                                            <input matInput formControlName="gestion">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Vestimenta</mat-label>
                                                            <input matInput formControlName="vestimenta">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Departamento</mat-label>
                                                            <input matInput formControlName="departamento">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Provincia</mat-label>
                                                            <input matInput formControlName="provincia">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Municipio</mat-label>
                                                            <input matInput formControlName="municipio">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Lugar de los hechos</mat-label>
                                                            <input matInput formControlName="lugarHecho">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>Resumen</mat-label>
                                                            <textarea matInput formControlName="resumen"
                                                                rows="3"></textarea>
                                                        </mat-form-field>
                                                    </div>

                                                </mat-expansion-panel>
                                                <mat-expansion-panel [expanded]="true">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>Ubicación</mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <div id="map" class="map"></div>
                                                </mat-expansion-panel>
                                            </mat-accordion>

                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-span-1">
                                <div class="px-6 py-4 border-b flex items-center">
                                    <h2 class="title m-0">Fotografías</h2>
                                </div>
                                <div class="px-gutter py-4 grid grid-cols-2 sm:grid-cols-1 gap-6">
                                    <img [src]="foto()" class="rounded w-full" alt="Sin Foto">
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Datos complementarios">
                    <div class="p-6">
                        <div class="grid grid-flow-col gap-3">
                            <div class="col-span-1">
                                <div class="px-6 py-4 border-b flex items-center">
                                    <h2 class="title m-0 flex-auto">Datos complementarios</h2>
                                    <button mat-icon-button type="button" matTooltip="Reporte en pdf"
                                        (click)="downloadPdf()">
                                        <mat-icon class="text-secondary" svgIcon="mat:picture_as_pdf"></mat-icon>
                                    </button>
                                    <button mat-icon-button type="button" matTooltip="Reporte en imagen"
                                        (click)="downloadImage()">
                                        <mat-icon class="text-secondary" svgIcon="mat:image"></mat-icon>
                                    </button>
                                </div>

                                <div class="px-6 py-4 flex flex-col">
                                    <form (ngSubmit)="save()" [formGroup]="formCmp">
                                        <div class="px-6 py-4 flex flex-col">
                                            <mat-accordion multi>
                                                <mat-expansion-panel [expanded]="true">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>Campos del reporte</mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>NUMORIGINAL</mat-label>
                                                            <input matInput formControlName="numoriginal">
                                                        </mat-form-field>
                                                        <mat-form-field>
                                                            <mat-label>FECHA INGRESO</mat-label>
                                                            <input formControlName="fecha_ingreso" (click)="formDatepickerRef.open()"
                                                                (focus)="formDatepickerRef.open()" [matDatepicker]="formDatepickerRef" matInput>
                                                            <mat-datepicker-toggle [for]="formDatepickerRef" matSuffix></mat-datepicker-toggle>
                                                            <mat-datepicker #formDatepickerRef></mat-datepicker>
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>HORA INGRESO</mat-label>
                                                            <input formControlName="hora_ingreso" type="time" matInput>
                                                        </mat-form-field> 
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <!--<mat-form-field class="flex-auto">
                                                            <mat-label>NRO</mat-label>
                                                            <input matInput formControlName="nro">
                                                        </mat-form-field>-->
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>CÓDIGO</mat-label>
                                                            <input matInput formControlName="codigo">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>FOLIO</mat-label>
                                                            <input matInput formControlName="folio">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>DISTRITO</mat-label>
                                                            <input matInput formControlName="distrito">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>MACRODISTRITO</mat-label>
                                                            <input matInput formControlName="macrodistrito">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>OBSERVACIÓN</mat-label>
                                                            <input matInput formControlName="observacion">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>DESCRIPCIÓN APARICIÓN</mat-label>
                                                            <input matInput formControlName="descripcion_aparicion">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>TIEMPO DESAPARICIÓN</mat-label>
                                                            <input matInput formControlName="tiempo_desaparicion">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>ZONA</mat-label>
                                                            <input matInput formControlName="zona">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>DIRECCIÓN</mat-label>
                                                            <input matInput formControlName="direccion">
                                                        </mat-form-field>
                                                    </div>
                                                    <!--<div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>DISTRITO7</mat-label>
                                                            <input matInput formControlName="distrito7">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>MACRO8</mat-label>
                                                            <input matInput formControlName="macro8">
                                                        </mat-form-field>
                                                    </div>-->
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>POLICÍA COMPLEMENTO OBSERVACIONES</mat-label>
                                                            <input matInput formControlName="policia_complemento">
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>ORDEN</mat-label>
                                                            <input matInput formControlName="orden">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>ESTADO</mat-label>
                                                            <input matInput formControlName="estado">
                                                        </mat-form-field>
                                                    </div>
                                                    <!--<div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>OBSERVACIóN 2</mat-label>
                                                            <input matInput formControlName="observacion2">
                                                        </mat-form-field>
                                                    </div>-->
                                                    <div class="flex flex-col sm:flex-row sm:gap-4">
                                                        <mat-form-field>
                                                            <mat-label>NRO. DE REGISTRO</mat-label>
                                                            <input matInput formControlName="nro_registro">
                                                        </mat-form-field>
                                                        <mat-form-field class="flex-auto">
                                                            <mat-label>FECHA DE RECEPCIÓN DEL AFICHE DE DESAPARECIDO</mat-label>
                                                            <input formControlName="fecha_recepcion" (click)="formDate2.open()"
                                                                (focus)="formDate2.open()" [matDatepicker]="formDate2" matInput>
                                                            <mat-datepicker-toggle [for]="formDate2" matSuffix></mat-datepicker-toggle>
                                                            <mat-datepicker #formDate2></mat-datepicker>
                                                        </mat-form-field>
                                                    </div> 
                                                    
                                                    <div class="flex items-center justify-end gap-2">
                                                        <!--<button mat-button type="reset">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>-->
                                                        <button color="primary" mat-raised-button type="submit">{{appSettings.DIALOG_BUTTON_SAVE_POSITIVE}}</button>
                                                    </div>
                                                </mat-expansion-panel>
                                            </mat-accordion>

                                            
                                        </div>                                        
                                    </form>
                                </div>           
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Servicios de salud">
                    <div class="p-6">
                        <div *ngIf="showSalud">
                            <table [dataSource]="dataSource" class="w-full" mat-table matSort>
                                <ng-container matColumnDef="atencionFecha">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha de
                                        atención</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.atencionFecha }}</td>
                                </ng-container>
                                <ng-container matColumnDef="atencionHora">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Hora atención
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.atencionHora }}</td>
                                </ng-container>
                                <ng-container matColumnDef="atencionCentro">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Centro</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.atencionCentro }}</td>
                                </ng-container>
                                <ng-container matColumnDef="fechaCreacion">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha registro
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.fechaCreacion }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="appSettings.PAGE_SIZE_OPTIONS"
                                [pageSize]="appSettings.PAGE_SIZE" class="sticky left-0"></mat-paginator>
                        </div>
                        <div class="bg-yellow-100 rounded-lg py-5 px-6 text-base text-yellow-700 inline-flex items-center w-full"
                            role="alert" *ngIf="!showSalud">
                            <mat-icon svgIcon="mat:warning" class="icon-sm mr-2"></mat-icon> No se
                            encontraron datos
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Servicios de DNA">
                    <div class="p-6">
                        <div *ngIf="showDna">
                            <table [dataSource]="dataSourceDna" class="w-full" mat-table matSort>
                                <ng-container matColumnDef="fechaRegistro">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha de
                                        atención</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.fechaRegistro }}</td>
                                </ng-container>
                                <ng-container matColumnDef="horaRegistro">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Hora
                                        atención
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.horaRegistro }}</td>
                                </ng-container>
                                <ng-container matColumnDef="lugarRemision">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Lugar
                                        remisión
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.lugarRemision }}</td>
                                </ng-container>
                                <ng-container matColumnDef="responsableSeguimiento">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>
                                        Responsable
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.responsableSeguimiento }}</td>
                                </ng-container>
                                <ng-container matColumnDef="atencion">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Atención
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.atencion }}</td>
                                </ng-container>
                                <ng-container matColumnDef="albergue">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Albergue
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.albergue }}</td>
                                </ng-container>
                                <ng-container matColumnDef="derivacion">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Derivación
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.derivacion }}</td>
                                </ng-container>
                                <ng-container matColumnDef="entrega">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Entrega
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.entrega }}</td>
                                </ng-container>
                                <ng-container matColumnDef="fechaCreacion">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha
                                        registro
                                    </th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{
                                        element.fechaCreacion }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDna"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDna;">
                                </tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="appSettings.PAGE_SIZE_OPTIONS"
                                [pageSize]="appSettings.PAGE_SIZE" class="sticky left-0"></mat-paginator>
                        </div>
                        <div class="bg-yellow-100 rounded-lg py-5 px-6 text-base text-yellow-700 inline-flex items-center w-full"
                            role="alert" *ngIf="!showDna">
                            <mat-icon svgIcon="mat:warning" class="icon-sm mr-2"></mat-icon> No se
                            encontraron datos
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </vex-page-layout-content>
</vex-page-layout>